import React from 'react';
import { product } from '../data/landing';
const BASE_CLASSES = 'inline-flex items-center justify-center rounded-xl bg-clay px-8 py-5 text-center font-sans text-lg font-bold uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_0_#9E3F1D] transition-[transform,background-color] duration-150 ease-smooth hover:bg-clay-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-clay-dark active:translate-y-1 active:shadow-[0_2px_0_0_#9E3F1D] sm:text-xl';
export const CHECKOUT_BUTTON_ID = 'boton-compra';
type CtaButtonProps = {
  className?: string;
  label?: string;
  /**
   * 'scroll' buttons carry the reader down to the final purchase button.
   * 'checkout' is the single button that starts the payment.
   */
  variant?: 'scroll' | 'checkout';
};
export function CtaButton({
  className = '',
  label,
  variant = 'scroll'
}: CtaButtonProps) {
  const text = label ?? product.ctaLabel;
  if (variant === 'checkout') {
    return <a id={CHECKOUT_BUTTON_ID} href={product.checkoutUrl} target="_blank" rel="noopener noreferrer" className={`${BASE_CLASSES} ${className}`} data-id="element-28" data-mp="35xnyqs4zryib">
        {text}
      </a>;
  }
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const target = document.getElementById(CHECKOUT_BUTTON_ID);
    if (!target) return;
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
    window.setTimeout(() => target.focus({
      preventScroll: true
    }), 600);
  };
  return <a href={`#${CHECKOUT_BUTTON_ID}`} onClick={handleClick} className={`${BASE_CLASSES} ${className}`} data-id="element-29" data-mp="3sv94rrm8pmdo">
      {text}
    </a>;
}